var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.inline ? 'inline-loader-holder' : 'loader-holder'},[(_vm.addBackground)?_c('div',{staticClass:"backdrop"}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"far fa-spinner fa-spin fa-3x",class:_vm.inline ? 'inline-loader' : 'loader'})])
}
var staticRenderFns = []

export { render, staticRenderFns }